<template>
  <div class="field-wrap fillin-field-wrap signature-wrap">
    <input :name="`${name}`" :id="`${name}`" ref="signatureData" :data-rule-required="`${required}`" style="display: none;" type="text">
    <canvas ref="signature" @mousedown="onMouseDown" @mousemove="onMouseMove" @mouseup="onMouseUp" @mouseout="onMouseUp"  width="300" height="125">
    </canvas>
    <div class="button-placeholder">
      <input v-if="!disabled && signatureImg" class="button-undo" type="button" value="Undo last stroke" @click="undoLastStroke">
    </div>
  </div>
</template>

<script>

export default {
  name: "SignatureComponent",
  props: {
    id: String,
    name: String,
    disabled: Boolean,
    required: String,
    savedSignature: String,
  },
  data() {
    return {
      signatureImg: null,
      states: [],
      signature: null,
      sign  : false,
      prevX : null,
      prevY : null
    }
  },
  mounted() {
    this.signature  = this.$refs.signature.getContext('2d');
    this.signature.fillStyle = "white";
    this.signature.strokeStyle  =  'black';
    this.signature.lineWidth  =  2;
    this.signature.fillRect(0, 0, this.$refs.signature.width, this.$refs.signature.height);
    
    if (this.savedSignature){
      var img = new Image;
      var ctx = this.signature;
      img.onload = function(){
        ctx.drawImage(img,0,0);
      };
      img.src = this.savedSignature;

      this.signatureImg = this.savedSignature;
      this.$refs.signatureData.value = this.savedSignature;
    }
  },

  methods: {

    onMouseDown($event){
      if ( this.disabled ) return;

      this.sign = true
      this.prevX = $event.offsetX
      this.prevY = $event.offsetY
    },

    onMouseUp(){
      if ( this.disabled ) return;

      if (this.sign){

        if (this.signatureImg){
          this.states.push(this.signatureImg);
        }

        const toDataURL = this.$refs.signature.toDataURL("image/jpeg",1.0) 
        this.$refs.signatureData.value = toDataURL
        this.signatureImg = toDataURL;

      }
      this.sign = false;
    },

    onMouseMove($event) {
      if(this.sign) {
        const  currX  = $event.offsetX
        const  currY  = $event.offsetY
        this.draw(this.prevX, this.prevY, currX, currY)
        this.prevX  =  currX
        this.prevY  =  currY
      }
    },

    draw(depX, depY, destX, destY){
        this.signature.beginPath()
        this.signature.moveTo(depX, depY)
        this.signature.lineTo(destX, destY)
        this.signature.closePath()
        this.signature.stroke()
    },

    deleteSignature($event){
      $event.preventDefault()
      this.signature.clearRect(0, 0, this.$refs.signature.width, this.$refs.signature.height)
      this.signature.fillRect(0, 0, this.$refs.signature.width, this.$refs.signature.height);

      this.signatureImg = null;
      this.$refs.signatureData.value = null;
      this.states = [];
    },

    undoLastStroke($event){
      $event.preventDefault();
      var img = new Image;
      var ctx = this.signature;
      img.onload = function(){
        ctx.drawImage(img,0,0);
      };
      const imgData = this.states.pop();
      if( imgData ){
        img.src = imgData;
        this.$refs.signatureData.value = imgData
        this.signatureImg = imgData
      }
      else{
        this.deleteSignature($event);
      }
    }
  }
}
</script>